
import { z } from "zod";

export const PvSystemProviderValues = ["SUNGEVITY", "SUNRUN", "VIVINT"] as const;
export const PvSystemProviderSchema = /* @__PURE__ */ z.enum(PvSystemProviderValues);
export const PvSystemProvider: (typeof PvSystemProviderSchema)["enum"] = { "SUNGEVITY": "SUNGEVITY", "SUNRUN": "SUNRUN", "VIVINT": "VIVINT" };
export type PvSystemProvider = (typeof PvSystemProviderValues)[number];
export const PvSystemProviderDisplayNames = { "SUNGEVITY": "Sungevity $1,000",
"SUNRUN": "Sunrun",
"VIVINT": "Vivint $499", } satisfies Record<PvSystemProvider, string>;
